import React from 'react';
import { Link } from 'react-router-dom';
import { nepalImageSrc, nepalImageAlt } from '../../data/nepalImages';

export function NepalPhoto({ imageKey, alt, className = '' }) {
	if (!imageKey) return null;
	return (
		<img
			src={nepalImageSrc(imageKey)}
			alt={alt || nepalImageAlt(imageKey)}
			className={className}
			loading="lazy"
		/>
	);
}

export function NepalIllustration({ variant, className = '' }) {
	return <div className={`nepal-illus nepal-illus--${variant} ${className}`} aria-hidden="true" />;
}

export function ExperienceTile({ exp }) {
	const hasPhoto = Boolean(exp.imageKey);
	const sizeClass = exp.size ? `home-exp__tile--${exp.size}` : '';

	return (
		<Link to={exp.route} className={`home-exp__tile ${sizeClass}`}>
			<div className="home-exp__tile-media">
				{hasPhoto ? (
					<NepalPhoto imageKey={exp.imageKey} className="home-exp__tile-img" />
				) : (
					<NepalIllustration variant={exp.illustration} className="home-exp__tile-img" />
				)}
				<div className="home-exp__tile-overlay" />
			</div>
			<div className="home-exp__tile-body">
				<span className="home-exp__tile-emoji" aria-hidden="true">{exp.emoji}</span>
				<h3 className="home-exp__tile-title">{exp.title}</h3>
				<p className="home-exp__tile-sub">{exp.subtitle}</p>
			</div>
		</Link>
	);
}

export function EditorialSection({ eyebrow, title, lead, children, alt = false, id }) {
	return (
		<section className={`home-editorial${alt ? ' home-editorial--alt' : ''}`} aria-labelledby={id}>
			<div className="home-editorial__inner">
				{eyebrow && <span className="home-editorial__eyebrow">{eyebrow}</span>}
				{title && <h2 id={id} className="home-editorial__title">{title}</h2>}
				{lead && <p className="home-editorial__lead">{lead}</p>}
				{children}
			</div>
		</section>
	);
}

export function StoryCard({ to, imageKey, illustration, title, subtitle, tag, large = false }) {
	return (
		<Link to={to} className={`home-story${large ? ' home-story--large' : ''}`}>
			<div className="home-story__media">
				{imageKey ? (
					<NepalPhoto imageKey={imageKey} className="home-story__img" />
				) : (
					<NepalIllustration variant={illustration} className="home-story__img" />
				)}
			</div>
			<div className="home-story__body">
				{tag && <span className="home-story__tag">{tag}</span>}
				<h3 className="home-story__title">{title}</h3>
				{subtitle && <p className="home-story__sub">{subtitle}</p>}
			</div>
		</Link>
	);
}
